import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


const Menu = ({ isOpen, setIsOpen }) => {
    // react-router hook
    const location = useLocation();

    const handleClick = () => {
        setIsOpen(!isOpen)
    };

    const path = location.pathname;
    useEffect(() => {

    }, [path])

    return (
        <nav className={`bg-green-300 w-full h-full z-40 lg:col-span-1 flex-col items-center justify-center ${isOpen ? 'flex' : 'hidden'} lg:flex absolute lg:relative`}>
            <img src='https://i.ibb.co/hxNLG5c/sindabad.jpg' alt="sindabad" className='w-36 rounded-full mb-4' />
            <ul className='' >
                <li onClick={handleClick} className={`list ${path === '/' ? 'border-gray-800 text-gray-800 border-opacity-100 border-l-4' : 'border-l-4 border-opacity-0 text-gray-500'}`}>
                    <Link to='/'>Home</Link>
                </li>
                <li onClick={handleClick} className={`list ${path === '/about' ? 'border-gray-800 text-gray-800 border-opacity-100 border-l-4' : 'border-l-4 border-opacity-0 text-gray-500'}`}>
                    <Link to='/about'>About</Link>
                </li>
                <li onClick={handleClick} className={`list ${path === '/skills' ? 'border-gray-800 text-gray-800 border-opacity-100 border-l-4' : 'border-l-4 border-opacity-0 text-gray-500'}`}>
                    <Link to='/skills'>Skills</Link>
                </li>
                <li onClick={handleClick} className={`list ${path === '/projects' ? 'border-gray-800 text-gray-800 border-opacity-100 border-l-4' : 'border-l-4 border-opacity-0 text-gray-500'}`}>
                    <Link to='/projects'>Projects</Link>
                </li>
                <li onClick={handleClick} className={`list ${path === '/contact' ? 'border-gray-800 text-gray-800 border-opacity-100 border-l-4' : 'border-l-4 border-opacity-0 text-gray-500'}`}>
                    <Link to='/contact'>Contact</Link>
                </li>
            </ul>
        </nav>
    )
}

export default Menu;
